import React from 'react'
import { TextField } from '@deal/components'
import { getInputUnit } from '#src/services/path'
import { NumericPathFlowQuestionUnitType } from '#src/generated/graphql'
import styles from './styles.css'
import { NumericPathFlowQuestionProps } from '../'

interface HeightQuestionState {
  feet?: number
  inches?: number
  feetState: {
    errorText?: string
    isValid?: boolean
  }
  inchesState: {
    errorText?: string
    isValid?: boolean
  }
}

class HeightQuestion extends React.Component<NumericPathFlowQuestionProps, HeightQuestionState> {
  constructor(props: NumericPathFlowQuestionProps) {
    super(props)

    this.state = {
      feetState: {},
      inchesState: {}
    }

    if (props.value !== null && props.value !== undefined) {
      const { feet, inches } = this.inchesToFeet(props.value)
      this.state = {
        ...this.state,
        inches,
        feet
      }

      this.handleChange()
    }

    this.handleIsFieldValid = this.handleIsFieldValid.bind(this)
    this.handleHeightInput = this.handleHeightInput.bind(this)
  }

  public handleHeightInput(event: React.ChangeEvent<HTMLInputElement & HTMLTextAreaElement>) {
    const isFieldValid = this.handleIsFieldValid(event.target.value)

    if (isFieldValid) {
      this.props.onFieldValidityChanged(true)
    } else {
      this.props.onFieldValidityChanged(false)
    }

    const rawValue = parseInt(event.target.value, 10)
    const parsedValue = isNaN(rawValue) ? 0 : rawValue

    if (event.target.name === 'feet') {
      this.setState(
        {
          feet: parsedValue,
          feetState: {
            errorText: isFieldValid ? undefined : 'Plese enter a valid value for feet',
            isValid: isFieldValid
          }
        },
        this.handleChange
      )
    } else {
      this.setState(
        {
          inches: parsedValue,
          inchesState: {
            errorText: isFieldValid ? undefined : 'Please enter a valid value for inches',
            isValid: isFieldValid
          }
        },
        this.handleChange
      )
    }
  }

  public inchesToFeet(heightInInches: string | number) {
    const parsedInches = parseInt(heightInInches.toString(), 10)

    return {
      feet: Math.floor(parsedInches / 12),
      inches: parsedInches % 12
    }
  }

  public handleChange() {
    const inches = this.state.inches || 0
    const feet = this.state.feet || 0
    const heightInInches = feet * 12 + inches

    if (!isNaN(heightInInches)) {
      this.props.onFieldValueChanged({ value: heightInInches })
      this.props.onFieldValidityChanged(true)
    }
  }

  public handleIsFieldValid(value: string) {
    const { question } = this.props
    let isFieldValid = true

    if (value === undefined && question.required) {
      isFieldValid = false
    }

    if (!new RegExp(/^\d+$/).test(value)) {
      isFieldValid = false
    }

    // Some mildly logical values for both inputs until someone over 12' tall uses our site
    if (parseInt(value, 10) > 12) {
      isFieldValid = false
    }

    return isFieldValid
  }

  public render() {
    const { question } = this.props

    return (
      <div className={styles.dualInputContainer}>
        <div className={styles.dualInputWrapper}>
          <div className={styles.input}>
            <TextField
              type="tel"
              display={this.props.display}
              errorText={this.state.feetState.errorText}
              valid={this.state.feetState.isValid}
              autoFocus={false}
              label={question.internalName}
              labelHidden={true}
              placeholder="Feet"
              unit={getInputUnit(NumericPathFlowQuestionUnitType.FEET)}
              defaultValue={this.state.feet ? this.state.feet.toString() : undefined}
              name="feet"
              onChange={this.handleHeightInput}
            />
          </div>

          <div className={styles.input}>
            <TextField
              type="tel"
              display={this.props.display}
              errorText={this.state.inchesState.errorText}
              valid={this.state.inchesState.isValid}
              autoFocus={false}
              label={question.internalName}
              labelHidden={true}
              placeholder="Inches"
              unit={getInputUnit(NumericPathFlowQuestionUnitType.INCHES)}
              defaultValue={this.state.inches ? this.state.inches.toString() : undefined}
              name="inches"
              onChange={this.handleHeightInput}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default HeightQuestion
